import { Stack } from 'expo-router';

import GoBackButton from '@/components/buttons/GoBackButton';
import Title from '@/components/Title';
import PlatformContainer from '@/components/web/PlatformContainer';
import { i18n } from '@/utils/i18n';

const DonationPaymentLayout = () => {
  return (
    <PlatformContainer contentCustomClassnames="flex">
      <Stack>
        <Stack.Screen
          name="index"
          options={{
            headerShown: true,
            headerShadowVisible: false,
            headerBackVisible: false,
            headerTitle: () => <Title label={i18n.t('donation.confirm_payment_title')} />,
            headerLeft: () => <GoBackButton />
          }}
        />
        <Stack.Screen
          name="editSubscription"
          options={{
            headerShown: true,
            headerShadowVisible: false,
            headerBackVisible: false,
            headerTitle: () => <Title label={i18n.t('donation.edit_subscription_title')} />,
            headerLeft: () => <GoBackButton />
          }}
        />
      </Stack>
    </PlatformContainer>
  );
};

export default DonationPaymentLayout;
